module.exports = __webpack_public_path__ + "static/media/logo.e45fcc18.png";